<template>
  <div class="features root">
    <div class="features">
      <div class="feature" v-for="feature in features" :key="feature.text">
        <div class="image">
          <img :src="feature.image" />
        </div>
        <div class="text">{{feature.text}}</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  computed: {
    features() {
      return [
        ["Easy Loyalty Registration", "/images/ic-members.svg"],
        ["Points or Punch Card Options", "/images/ic-punch-card.svg"],
        ["Joining & Birthday Gifts", "/images/ic-members.svg"],
        ["CRM & Customer Data Insights", "/images/ic-help.svg"],
        ["SMS & Email Communication", "/images/ic-application.svg"],
        ["Automated Timed Promotions", "/images/wake.svg"]
      ].map(([text, image]) => ({ text, image }));
    }
  }
};
</script>

<style lang="scss" scoped>
.features.root {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  > *:not(:last-child) {
    margin-bottom: 95px;
  }

  > .header {
    max-width: 600px;
    > * {
      margin: 0 auto;
    }
    > *:not(:last-child) {
      margin-bottom: 15px;
    }

    .header {
      font-size: 36px;
      font-weight: bold;
      color: #333d4d;
    }
    .divider {
      width: 50px;
      height: 5px;
      background-color: #02b9e5;
    }
    .fee {
      font-size: 14px;
      font-weight: 600;
      color: #333d4d;
    }
  }

  .features {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-row-gap: 100px;

    .feature {
      max-width: 325px;
      font-size: 26px;
      font-weight: 300;
      color: #333d4d;

      .image {
        height: 60px;
        display: flex;
        justify-content: center;
        margin-bottom: 5px;
      }
    }
  }
  // Mobile
  #app.mobile & {
    padding: 0 20px;
    > *:not(:last-child) {
      margin-bottom: 40px;
    }

    > .header {
      .header {
        font-size: 22px;
      }
      .fee {
        font-size: 12px;
      }
    }
    .features {
      grid-template-columns: 1fr 1fr;
      grid-row-gap: 40px;
      .feature {
        font-size: 16px;
        font-weight: 300;
        max-width: 200px;
      }
    }
  }
}
</style>
